// @ts-nocheck
import React from 'react';
import {useTranslation} from 'react-i18next';
import {
  Dimensions,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {useDispatch} from 'react-redux';
import {hideAlert} from '../../actions/AlertActions';
import LottieView from '../../imports/Lottie';
import {Colors} from '../../styles/Colors';
import ConstantStyles from '../../styles/ConstantStyles';

const LoadingOverlay = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  return (
    <TouchableOpacity
      style={styles.screen}
      pointerEvents="box-only"
      onPress={() => {
        dispatch(hideAlert());
      }}
      activeOpacity={1}>
      <View style={styles.background} />
      <View
        style={{
          backgroundColor: '#fff',
          borderRadius: 10,
          justifyContent: 'center',
          alignItems: 'center',
          paddingHorizontal: ConstantStyles.size.horizontal_2,
          paddingVertical: ConstantStyles.size.vertical_1,
        }}>
        <LottieView
          autoPlay
          loop={true}
          source={require('../../assets/animations/trip_loading.json')}
          style={{
            height: 24,
            width: 24,
            transform: [
              {
                scale: 1.2,
              },
            ],
          }}
        />
        <Text
          style={{
            fontFamily: ConstantStyles.font.medium,
            fontSize: ConstantStyles.font.h4,
            color: Colors.txt_1,
            marginTop: ConstantStyles.size.vertical_3,
          }}>
          {t('payment_loading')}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

const windowHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
  screen: {
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    bottom: 0,
    height: windowHeight,
    zIndex: 1000,
  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'black',
    opacity: 0.5,
  },
  loading: {
    marginTop: 'auto',
    marginBottom: 'auto',
    alignSelf: 'center',
    width: '50%',
    height: '50%',
  },
});

export default LoadingOverlay;
